import { atom } from "recoil"

export const unreadMatchingMessageRequestIdState = atom<number>({
  key: "atoms/contact/unreadMatchingMessageRequestIdState",
  default: 0,
})
